import { render, staticRenderFns } from "./AlbumPlaylist.vue?vue&type=template&id=0ca36078&scoped=true"
import script from "./AlbumPlaylist.vue?vue&type=script&lang=js"
export * from "./AlbumPlaylist.vue?vue&type=script&lang=js"
import style0 from "./AlbumPlaylist.vue?vue&type=style&index=0&id=0ca36078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca36078",
  null
  
)

export default component.exports